import { render, staticRenderFns } from "./CreateGroupForm.vue?vue&type=template&id=a93d886a"
import script from "./CreateGroupForm.vue?vue&type=script&lang=js"
export * from "./CreateGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports